import React from "react";
import { NumberInput } from '@instructure/ui-number-input';

class IasFormNumberInput extends React.Component {
    state = {
      disabled: false,
      inline: false,
      messages: [],
      number: null,
      readOnly: false,
      showArrows: true,
      value: '',
      maxValue: 1,
      minValue: 0
    }

    handleChange = (event, value) => {
      value = this.bound(value);
      this.setState({
          messages: [],
          number: value ? Number(value) : null,
          value
      })

      this.props.onChange(this.props.name, Number(value));
    }

    handleDecrement = (event) => this.setState(({ number }) => {
      if (isNaN(number)) return
      if (number === null) return this.setNumber(this.state.minValue)
      if (isInteger(number)) return this.setNumber(number - 1)
      return this.setNumber(Math.floor(number))
    })

    handleIncrement = (event) => this.setState(({ number }) => {
      if (isNaN(number)) return
      if (number === null) return this.setNumber(this.state.minValue + 1)
      if (isInteger(number)) return this.setNumber(number + 1)
      return this.setNumber(Math.ceil(number))
    })

    handleBlur = (event) => this.setState(({ number, value }) => {
      if (isNaN(number)) return this.invalidNumber(value)
      if (number === null) return this.required()
      return this.setNumber(Math.round(number))
    })

    setNumber (n) {
      const number = this.bound(n)
      this.props.onChange(this.props.name, Number(number))
      return {
        messages: [],
        number,
        value: number
      }
    }

    bound (n) {
      if (n < this.state.minValue) return this.state.minValue
      if (n > this.state.maxValue) return this.state.maxValue
      return n
    }

    invalidNumber (value) {
      return {
        messages: [{ text: `'${value}' is not a valid number.`, type: 'error' }]
      }
    }

    required () {
      return {
        messages: [{ text: 'This is required.', type: 'error' }]
      }
    }

    render () {
      const { size, label, id, name, placeholder, isDisabled, isRequired, maxValue, minValue, messages: propMessages = [] } = this.props;
      this.state.maxValue = maxValue;
      this.state.minValue = minValue;
      return (
          <NumberInput
            renderLabel={label}
            messages={[...propMessages, ...this.state.messages]}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
            onDecrement={this.handleDecrement}
            onIncrement={this.handleIncrement}
            placeholder={placeholder}
            interaction={isDisabled
              ? 'disabled'
              : this.state.readOnly ? 'readonly' : 'enabled'
            }s
            isRequired={isRequired}
            showArrows={this.state.showArrows}
            value={this.state.value}
            id={id}
            name={name}
            size={size}
          />
      )
    }
}

// IE11 doesn't support Number.isInteger
function isInteger (number) {
    return Math.floor(number) === number
}

export default IasFormNumberInput;
